const Backofficebff: string = import.meta.env.VITE_BACKOFFICEBFF!;

export const AiIntegrationCommandURL = {
    Produce: Backofficebff + '/v1/ai-integration/produce',
    SimulateBatchComplete: Backofficebff + '/v1/ai-integration/simulate-batch-complete',
};
